export const ContactCategory = {
  before_order: "注文前",
  before_delivery: "注文後(お届け前)",
  after_delivery: "注文後(お届け後)",
  store_order: "店舗注文(ログイン必須)",
} as const
export type ContactCategoryKeys = keyof typeof ContactCategory

export const ContactSubCategoryBeforeOrder = {
  about_the_product: "製品に関する質問",
  about_the_order: "ご注文に関する質問",
  about_the_gift: "ギフトに関する質問",
  other: "その他",
} as const
export type ContactSubCategoryBeforeOrderKeys = keyof typeof ContactSubCategoryBeforeOrder

export const ContactSubCategoryBeforeDelivery = {
  about_the_product: "製品に関する質問",
  about_the_support: "キャンセル、返品、交換に関する質問",
  about_the_order: "ご注文に関する質問",
  about_the_gift: "ギフトに関する質問",
  about_the_delivery: "配送状況に関する質問",
  other: "その他",
} as const
export type ContactSubCategoryBeforeDeliveryKeys = keyof typeof ContactSubCategoryBeforeDelivery

export const ContactSubCategoryAfterDelivery = {
  about_the_product: "製品に関する質問",
  about_the_support: "返品、交換に関する質問",
  about_the_order: "ご注文に関する質問",
  about_the_gift: "ギフトに関する質問",
  about_the_delivery: "配送状況に関する質問",
  other: "その他",
} as const
export type ContactSubCategoryAfterDeliveryKeys = keyof typeof ContactSubCategoryAfterDelivery

export const SubCategoryList = {
  ...ContactSubCategoryBeforeOrder,
  ...ContactSubCategoryBeforeDelivery,
  ...ContactSubCategoryAfterDelivery,
} as const
export type SubCategoryListKeys = keyof typeof SubCategoryList

export const ContactSupportStatusBeforeDelivery = {
  cancel: "キャンセル",
  return: "返品",
  exchange: "交換",
} as const
export type ContactSupportStatusBeforeDeliveryKeys = keyof typeof ContactSupportStatusBeforeDelivery

export const ContactSupportStatusAfterDelivery = {
  return: "返品",
  exchange: "交換",
} as const
export type ContactSupportStatusAfterDeliveryKeys = keyof typeof ContactSupportStatusAfterDelivery

export const ContactSupportStatusList = {
  ...ContactSupportStatusBeforeDelivery,
  ...ContactSupportStatusAfterDelivery,
} as const
export type ContactSupportStatusKeys = keyof typeof ContactSupportStatusList

export const purchaseChannels = [
  "Amazon.co.jp",
  "楽天市場",
  "Yahoo!ショッピング",
  "TENTIAL公式オンラインストア",
  "実店舗",
  "ギフト",
  "その他",
] as const
export const purchaseChannelsForGuide = ["TENTIAL公式オンラインストア", "実店舗", "ギフト", "その他"] as const

export const getValueFromKey = (key: string, obj: { [key: string]: string }): string => {
  const entries = Object.entries(obj)
  for (const [currentKey, value] of entries) {
    if (currentKey === key) {
      return value
    }
  }
  return ""
}
